import { render, staticRenderFns } from "./IncidentReportFormHeader.vue?vue&type=template&id=539ecc3b"
import script from "./IncidentReportFormHeader.vue?vue&type=script&lang=js"
export * from "./IncidentReportFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports